<h2>Debug Logs</h2>

<magieno-logs-visualizer [changeRowColorBasedOnSeverity]="true"></magieno-logs-visualizer>
